export function filterLayout(array, propValue) {
    function deepCopy(obj) {
        return JSON.parse(JSON.stringify(obj));
    }
    let result = [];
    function filterItem(item) {
        if (item.data === propValue && (item.name && item.name.trim() !== "")) {
            result.push(deepCopy(item));
        }
        if (item.columns) {
            Object.keys(item.columns).forEach(col => {
                item.columns[col].forEach(subItem => filterItem(subItem));
            });
        }
    }
    array.forEach(item => filterItem(item));
    return result;
}

export function updatePropertyById(layout, id, property, value) {
    const recursiveUpdate = (item) => {
        if (item.id === id) {
            if (item[property] && typeof item[property] === 'object' && typeof value === 'object') {
                item[property] = { ...item[property], ...value };
            } else {
                item[property] = value;
            }
            return true;
        } else if (item.data === "Row" || item.data === "Accordion") {
          for (const col of Object.keys(item.columns)) {
            for (const colItem of item.columns[col]) {
              if (recursiveUpdate(colItem)) {
                return true;
              }
            }
          }
        }
        return false;
    };
    layout.some((item) => recursiveUpdate(item));
    return layout;
};